import { QuoteStatus } from '@features/invoices/enums/quoteStatus'

export const nonEditableQuoteStatuses: QuoteStatus[] = [QuoteStatus.Accepted, QuoteStatus.Invoiced, QuoteStatus.Deleted]
